import { makeStyles } from '@material-ui/core/styles';

export const useTicketErrorTextStyles = makeStyles((theme) => ({
  title: {
    fontSize: 26,
    fontWeight: 600,
    marginBottom: 18,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 16,
    textAlign: 'center',
  },
  contactWhatsapp: {
    marginTop: theme.spacing(3),
    textAlign: 'center',
    color: '#666',
    fontSize: '14px',
    lineHeight: '20px',
    '& a': {
      color: theme.palette.primary.main,
      fontWeight: 600,
      textDecoration: 'none',

      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
}));
